import filled from './filled';

export function sanitize(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c');
}

export default function search(query, valueS = []) {
  if (!filled(query)) {
    return false;
  }

  if (Array.isArray(valueS)) {
    return valueS.some((value) => search(query, value));
  }

  if (typeof valueS === 'string' && typeof query === 'string') {
    return sanitize(valueS).search(new RegExp(sanitize(query.replace(/\\/g, '\\\\')))) >= 0;
  }

  return valueS === query;
}
